// App.js
import React from 'react';
import { I18n } from 'aws-amplify';
import { Amplify } from 'aws-amplify';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import { ReserveProviderV2 } from './Common/Context/ReserveContextV2';
import { AlertProvider } from './Common/Context/AlertContext';
import { SalesRootProvider } from './Common/Context/SalesRootContext';

import awsExports from './aws-exports';
import { vocabularies } from './contents/jaDictionary';

import Layout from './Common/components/layout';
import LoginPage from './login/loginpage';
import CalendarTlap from './CarenderManager/Pages/CalendarTlap';
import Confirmed from './ConfirmedManager/Pages/Confirmed';
import SalesRootsV2 from './SalesRootManager/Pages/SalesRootsV2';

import "./css/style.css";
import "./css/ress.min.css";
import '@aws-amplify/ui-react/styles.css';
import { Restricted } from './Common/components/Restricted';

I18n.putVocabularies(vocabularies);
I18n.setLanguage('ja');
console.log(I18n.get('Sign in'));

Amplify.configure(awsExports);

function App() {
    const location = useLocation();
    return (
        <React.StrictMode>
            <SalesRootProvider>
                <AlertProvider>
                    <Authenticator.Provider>
                        <ReserveProviderV2>
                            <Routes location={location} key={location.pathname}>
                                <Route path="/" element={<Layout />}>
                                    <Route path="/login" element={<LoginPage />} />
                                    <Route path="/SalesRoots" element={<SalesRootsV2 />} />
                                    <Route path="/carendar" element={<CalendarTlap />} />
                                    <Route path="/confirmed" element={<Confirmed />} />
                                </Route>
                            </Routes>
                            <Restricted />
                        </ReserveProviderV2>
                    </Authenticator.Provider>
                </AlertProvider>
            </SalesRootProvider>
        </React.StrictMode>
    );
}

export default App;
